export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto bg-background-50 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              移动阅读
            </h2>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6">
              星球漫画完美适配手机与平板设备，无需下载任何免费漫画APP，打开浏览器即可享受流畅的下拉式免费漫画阅读。支持夜间模式、字号调节、书签收藏等贴心功能，让你随时随地畅读好看的免费漫画。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line"></i>
                立即体验
              </a>
              <span className="text-foreground-400 text-xs">
                无需安装，浏览器即开即看
              </span>
            </div>
          </div>
          <div className="shrink-0">
            <div className="w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20manga%20reading%20interface%20with%20Japanese%20comic%20style%20artwork%20on%20screen%2C%20vertical%20scrolling%20layout%2C%20warm%20orange%20accent%20colors%2C%20clean%20minimal%20device%20frame%2C%20modern%20UI%20design%2C%20no%20visible%20text%20content&width=600&height=1067&seq=app-mockup-comics-01&orientation=portrait"
                alt="星球漫画移动端阅读"
                title="星球漫画手机端免费看漫画"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}